import fingerPrintInstance from "../store/storeInitializer/initialiseFingerprint";

export const collectData = async ({ detector }) => {
  const data = await detector.then(async (result) => {
    const collectedData = await result.collect();
    return collectedData;
  });
  return Promise.resolve(data);
};

export const createHash = async ({
  detector,
  detectorData,
  response,
  secretKey,
}) => {
  const data = await detector.then(async (result) => {
    const collectedData = await result?.createHash(
      detectorData,
      response,
      secretKey
    );
    return collectedData;
  });

  return Promise.resolve(data);
};

export const getHashValue = (data) => {
  const { getFPInstance } = fingerPrintInstance;
  const { detectorData, response } = data;
  const APP_INSTANCE = "71346f376e396231";
  const binaryKeyArray = APP_INSTANCE.match(/.{1,2}/g)?.map((key) =>
    parseInt(key, 16)
  );
  const createUint8Array = new Uint8Array(binaryKeyArray);
  const decodedValue = new TextDecoder().decode(createUint8Array);
  return createHash({
    detector: getFPInstance(),
    detectorData,
    response,
    secretKey: decodedValue,
  });
};
